import type { ImageAnalyses } from '@/@types/latestImagesV2';
import { ImageThumbnail } from '@/modules/claims/cleanClaims/images/ImageThumbnail';
import type { GetClaimSummaryResponse } from '@/modules/claims/freeClaims/insuranceExport/types';

import {
  parseImageFromID,
  parseImageTeethIdsFromID,
} from './claimImageSelectorHelpers';
import { SelectableImageCard } from './SelectableImageCard';

type ImageGridSubsectionProps = {
  title: React.ReactNode;
  entries: Record<string, boolean>;
  claimSummary: GetClaimSummaryResponse | undefined;
  filteredRadiographs: ImageAnalyses[];
  filteredColorImages: ImageAnalyses[];
  selectedTreatmentIds: string[];
  onToggle: (imageID: string) => void;
};

export const ImageGridSubsection = ({
  title,
  entries,
  claimSummary,
  filteredRadiographs,
  filteredColorImages,
  selectedTreatmentIds,
  onToggle,
}: ImageGridSubsectionProps) => {
  if (Object.keys(entries).length === 0) return null;

  return (
    <div className="vai-flex vai-flex-col vai-gap-2">
      <h3 className="vai-text-sm vai-font-semibold vai-text-foreground">
        {title}
      </h3>
      <div className="vai-grid md:vai-grid-cols-3 vai-gap-3">
        {Object.entries(entries).map(([imageID, checked]) => {
          const image = parseImageFromID(
            imageID,
            filteredRadiographs,
            filteredColorImages,
          );
          if (!image) return null;
          return (
            <SelectableImageCard
              key={imageID}
              checked={checked}
              onChange={() => onToggle(imageID)}
            >
              <div className="vai-h-40 vai-w-full vai-bg-gray-100 vai-flex vai-items-center vai-justify-center">
                <ImageThumbnail
                  image={image}
                  height={250}
                  width={250}
                  enabledFindings={[]}
                  includedTeethIds={parseImageTeethIdsFromID(
                    imageID,
                    claimSummary,
                    filteredRadiographs,
                    filteredColorImages,
                    selectedTreatmentIds,
                  )}
                  showIncipientCariesRed
                />
              </div>
            </SelectableImageCard>
          );
        })}
      </div>
    </div>
  );
};
